import Fetch from 'utils/fetch'

export const searchReleaseVersionById = (idReleaseVersion) => {
    return Fetch.get(`/releaseVersion/${idReleaseVersion}`).then(({ data }) => data)
}

export const saveReleaseVersion = (releaseVersion) => {
    return Fetch.post(`/releaseVersion`, releaseVersion)
}